import { AnyAction } from '@reduxjs/toolkit';
import { SET_BILLING_ADDRESS } from '../action-types';
import { CreateCustomerRoutine } from '~modules/Companies/redux-routines';
import type { ISetBillingAddressAction } from '../actions';
import type { IBillingAddressRegistrationState } from '../interfaces';

export const initialState: IBillingAddressRegistrationState = {
  data: {},
};

export const billingAddressRegistrationReducer = (
  state: IBillingAddressRegistrationState = initialState,
  action: AnyAction,
): IBillingAddressRegistrationState => {
  switch (action.type) {
    case SET_BILLING_ADDRESS:
      return {
        ...state,
        data: { ...state.data, ...(action as ISetBillingAddressAction).payload },
      };
    case CreateCustomerRoutine.SUCCESS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
